import React from 'react';
import { DownloadIcon, StarIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="relative w-full bg-cream pt-12 pb-16 px-4 md:pt-20 md:pb-24 overflow-hidden" data-id="element-37">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-38">
        {/* Text Content */}
        <div className="flex flex-col items-start z-10" data-id="element-39">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-rose-gold/10 border border-rose-gold/20 mb-6" data-id="element-40">
            <StarIcon className="w-3 h-3 text-rose-gold fill-rose-gold" data-id="element-41" />
            <span className="text-xs font-bold tracking-widest text-rose-gold uppercase" data-id="element-42">
              PIEL DE VIDRIO: LUJO DE FARMACIA
            </span>
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-brown-primary leading-[1.1] mb-6" data-id="element-43">
            Deja de financiar los envases de lujo y empieza a financiar tus
            resultados.
          </h1>

          <p className="text-2xl font-serif italic text-rose-gold mb-6" data-id="element-44">
            Logra una "Piel de Vidrio" real usando activos de farmacia mexicana
            por el precio de una salida al cine.
          </p>

          <p className="text-lg md:text-xl text-brown-secondary mb-8 leading-relaxed max-w-xl" data-id="element-45">
            El sistema de Skin-Cycling de 4 noches que las marcas de $4,000
            pesos no quieren que descubras. Sin citas caras, sin irritación y
            sin tirar tu quincena.
          </p>
        </div>

        {/* Image Content + CTA below */}
        <div className="relative w-full flex flex-col items-center lg:items-end" data-id="element-46">
          <div className="relative w-full max-w-md lg:max-w-full aspect-[4/5] lg:aspect-square" data-id="element-47">
            <div className="absolute inset-0 bg-gold-soft/10 rounded-t-[10rem] rounded-b-lg transform rotate-3 scale-95 z-0" data-id="element-48"></div>
            <img src="https://cdn.magicpatterns.com/uploads/7AVKnA4fwHJWrePDV3uG4e/mockup-3.png" alt="Piel de Vidrio Guía Digital" width={600} height={750} decoding="async" fetchPriority="high" className="relative z-10 w-full h-full object-cover rounded-lg shadow-2xl" data-id="element-49" />
          </div>

          <div className="flex flex-col w-full sm:w-auto items-center mt-8" data-id="element-50">
            <a href="#precio" className="w-full sm:w-auto px-8 py-4 bg-rose-gold hover:bg-rose-dark text-white text-lg font-bold tracking-wide rounded-sm transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 text-center inline-block" data-id="element-51">
              QUIERO MI PIEL DE VIDRIO POR $9 USD
            </a>
            <div className="mt-3 flex items-center justify-center gap-2 text-sm text-brown-secondary/80" data-id="element-52">
              <DownloadIcon className="w-4 h-4" data-id="element-53" />
              <span data-id="element-54">Descarga inmediata · Acceso de por vida</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}